import BusinessInfoPanel from "./BusinessInfoPanel";

export default BusinessInfoPanel;
